import script from "./MyAIChat.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAIChat.vue?vue&type=script&setup=true&lang=js"

import "./MyAIChat.vue?vue&type=style&index=0&id=6fd1b2a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fd1b2a9"]])

export default __exports__